import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataEe from './phonics/phonics_data_ee';

/**
 * Phonics Letter Ee 页面
 * 复用 PhonicsAtoZ 通用组件，只传入 Ee 数据
 */
function PhonicsEe() {
  return <PhonicsAtoZ letterData={letterDataEe} />;
}

export default PhonicsEe;
